var map = {
	"./Email.svg": "f615",
	"./Pending.svg": "1a67",
	"./accreditations/download-zip-icon.svg": "2536",
	"./accreditations/warning-outline.svg": "6e59",
	"./add-token-image.png": "1d32",
	"./alert-icon.svg": "3293",
	"./arrow-down.svg": "2e6e",
	"./auth/authy.svg": "a63a",
	"./auth/g_auth.svg": "75d9",
	"./blockchains/algorand.svg": "6d0e",
	"./blockchains/avalanche.svg": "784c",
	"./blockchains/besu.svg": "c9e5",
	"./blockchains/ethereum.svg": "eaea",
	"./blockchains/ganache.svg": "dac1",
	"./blockchains/polygon.svg": "7309",
	"./blockchains/quorum.svg": "65d1",
	"./check-icon.svg": "3a0d",
	"./check.svg": "6aa8",
	"./close-vector.svg": "cf0e",
	"./copy-to-clipboard.svg": "cbaf",
	"./fallback-image.jpg": "90de",
	"./fallback-pdf.jpg": "f788",
	"./illustration.png": "f2a2",
	"./infoIcon.svg": "27d6",
	"./issuer-list.svg": "1ab9",
	"./left-selected.svg": "1bc6",
	"./left.svg": "0182",
	"./logo-openfinance.png": "e241",
	"./logo/aspen.png": "18f6",
	"./logo/bcap.png": "afa9",
	"./logo/coinmint.png": "e56b",
	"./logo/default_bc_logo.png": "e9d3",
	"./logo/logo-google.png": "6274",
	"./logo/logo.png": "21dd",
	"./logo/science.png": "c288",
	"./logo/sec-markets-logo.svg": "1134",
	"./logo/securitize-id-logo.svg": "5a4c",
	"./logo/securitize.png": "f5ed",
	"./logo/seftoken.png": "35eb",
	"./logo/spicevc.png": "61d5",
	"./no-avatar.png": "3aaf",
	"./no-img.svg": "2888",
	"./open-vector.svg": "cfa0",
	"./outreach/personal-information.svg": "1a33",
	"./outreach/tooltip.svg": "21a6d",
	"./placeholder-avatar.png": "a3c6",
	"./replay.svg": "71aa",
	"./right-selected.svg": "52c8",
	"./right.svg": "50d7",
	"./sign.svg": "d7bd",
	"./theme/about-background.jpg": "6b1b",
	"./theme/announcement-background.jpg": "067d",
	"./theme/login-background.jpg": "ca8e",
	"./theme/logo-dark.png": "bf1d",
	"./theme/logo.png": "a337",
	"./theme/token.png": "389a",
	"./theme/upload.png": "b99b",
	"./theme/wizard-background.jpg": "9999",
	"./upgrade-issuer.svg": "823d",
	"./wallets/CoinBase.svg": "7337",
	"./wallets/Metamask.svg": "936e",
	"./wallets/WalletConnect.svg": "e57b",
	"./warning-icon.svg": "97c4",
	"./wizard-background.jpg": "e42e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";